define(
    'viewmodels/secured/explorer/details/tabs/actions/actionsAddTemplate/actionsAddTemplate',[
        "viewmodels/secured/explorer/context",
        "viewmodels/ViewModelNotification",
        "services/service.documents",
        "services/config",
        "providers/dataprovider",
        "i19n!i19n/strings",
        "plugins/router",
        "dropzone",
        "viewmodels/controller",
        "extensions/file.extensions"
    ],
    function (ctx, ViewModelNotification, documentsService, config, dataProvider, i19n, router, Dropzone, shell, fileExt) {
        var $grid = null;
        var grid = null;

        var vm = new ViewModelNotification(
        {
            i19n: i19n,
            folderId: null,
            subheading: ko.observable(),
            headings: ko.observable(),
            isUploadDocument: ko.observable(false),
            isVisible: ko.observable(false),
            documentTemplates: ko.observableArray([]),
            searchTemplate: ko.observable(""),
            searchTemplateIsSelected: ko.observable("").extend({ notify: 'always' }),
            searchCount: ko.observable(0),
        });

        vm.activate = function () {
            if (!ctx.current.folder || !ctx.current.folder.folderId) {
                vm.isVisible(false);

                if (sessionStorage.__url) {
                    window.location.href = sessionStorage.__url;
                } else {
                    router.navigate("explorer");
                }
                //router.navigate("explorer");

                return false;
            }

            vm.searchTemplate("");
            vm.searchCount(0);
            vm.isVisible(true);
            vm.folderId = ctx.current.folder.folderId;
            vm.notifications([]);

            vm.headings(ctx.current.folder.name());
            vm.subheading(ctx.current.library.name + (ctx.current.folder.listId ? '/' + ctx.current.library.list.active.selectedRow().label : ""));

            return loadDocumentTemplates()
            .done(function () {
                if (grid)
                    grid.dataSource.read();
            });
        };
        vm.attached = function () {
            buildGrid();

            vm.searchTemplate.subscribe(function (newvalue) {
                if (grid) {
                    vm.searchTemplateIsSelected(false);

                    var filters = [
                        { field: 'name', operator: "contains", value: newvalue },
                        { field: 'parentId', operator: "eq", value: "" }
                    ];
                    grid.dataSource.filter({ logic: "or", filters: filters });

                    updateUISelectedTemplate();
                }
            });
            vm.searchTemplateIsSelected.subscribe(function (newvalue) {
                if (grid) {
                    if (newvalue) {
                        vm.searchTemplate("");

                        var filters = [
                            { field: 'isSelected', operator: "eq", value: true },
                            { field: 'parentId', operator: "eq", value: "" }
                        ];
                        grid.dataSource.filter({ logic: "or", filters: filters });
                    } else {
                        grid.dataSource.filter([]);
                    }

                    updateUISelectedTemplate();
                }
            });

            function updateUISelectedTemplate() {
                if (!grid)
                    return;

                grid.__isSelecting = true;
                $.map(grid.element.children(), function (d, i) {
                    if (grid.dataSource.view()[i].isSelected)
                        grid.select(d);
                });
                grid.__isSelecting = false;

                vm.isUploadDocument(grid.select().length > 0);

                var ii = 0;
                for (var i = 0; i < grid.dataSource.view().length; i++) {
                    if (grid.dataSource.view()[i].parentId == "")
                        ii++;
                }
                vm.searchCount(grid.dataSource.view().length - ii);
            }

            vm.isUploadDocument(grid.select().length > 0);            
        };

        vm.close = function () {
            if (sessionStorage.__url) {
                window.location.href = sessionStorage.__url;
            } else {
                router.navigate("explorer");
            }
            //router.navigate("explorer");
        };

        vm.addDocuments = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting && vm.isUploadDocument() && vm.searchTemplate() == "";
            },
            execute: function (complete) {
                var documentIds = _.map(grid.select(), function (itm) {
                    var d = grid.dataSource.data()[$(itm).index()];

                    return { documentId: d.documentId };
                });

                if (documentIds.length > 0) {
                    documentsService.actions
                    .copyDocumentsTemplate(documentIds, vm.folderId)
                    .done(function (result) {
                        vm.isVisible(false);

                        if (sessionStorage.__url) {
                            window.location.href = sessionStorage.__url;
                        } else {
                            router.navigate("explorer");
                        }
                        //router.navigate("explorer");

                        ctx.onReloadFolders({ documentId: documentIds[0].documentId, _updateNode: { docCount: ctx.current.folder.docCount + documentIds.length, text: ctx.current.folder.name() }, isLoadResults: true });
                    })
                    .fail(function (e) {
                        e.stopPropagation = true;

                        vm.notify('error', i19n.to.anerrorhasoccuredpleasetryagain);

                        console.error(e);
                    })
                    .always(function (result) {
                        complete();
                    });
                } else {
                    uploadFiles();

                    complete();
                }

                function uploadFiles() {
                    vm.clearNotifications();

                    vm.isUploadDocument(true);
                }
            }
        });
        vm.clearSearchTemplate = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                vm.searchTemplate('');

                complete();
            }
        });

        return vm;

        function buildGrid() {
            if (grid)
                return;

            $grid = $("#doc-template-view");

            grid = $grid.kendoListView({
                dataSource: getGridDataSource(),
                selectable: "multiple",
                change: function () {
                    if (!grid.__isSelecting) {
                        var selected = this.select();
                        var index = selected.index();
                        var itm = grid.dataSource.view()[index];

                        if (itm.parentId == "") {
                            itm.set("isSelected", false);

                            $(selected).removeClass("k-state-selected");
                        } else {
                            itm.set("isSelected", !itm.isSelected);
                        }

                        grid.__isSelecting = true;
                        $.map(grid.element.children(), function (d, i) {
                            if (grid.dataSource.view()[i]) {
                                if (grid.dataSource.view()[i].isSelected) {
                                    grid.select(d);
                                }
                            }
                        });
                        grid.__isSelecting = false;

                        if (vm.searchTemplateIsSelected()) {
                            vm.searchTemplateIsSelected(true);
                        }

                        vm.isUploadDocument(grid.select().length > 0);
                    }
                },
                template: kendo.template($("#doc-template-view-template").html())
            }).data("kendoListView");

            function getGridDataSource() {
                return new kendo.data.DataSource({
                    transport: {
                        read: function (callbacks) {
                            callbacks.success(vm.documentTemplates());
                        }
                    },
                    schema: {
                        model: {
                            id: "id",
                            fields: {
                                parentId: { type: "string" },
                                id: { type: "string" },
                                icon: { type: "string" },
                                name: { type: "string" },
                                description: { type: "string" },
                                sortKey: { type: "string" },
                                isSelected: { type: "bool" }
                            }
                        }
                    }
                });
            }

            grid.dataSource.read();
        }
        function loadDocumentTemplates() {
            var dfd = $.Deferred();

            dataProvider.libraries
            .getLibraries()
            .done(function (d1) {
                var promises = [];
                var data = [];

                d1 = _.filter(d1, function (itm) { return itm.isTemplateSource; });

                var libraries = _.map(d1, function (itm) {
                    return {
                        parentId: "",
                        id: itm.libraryId,
                        documentId: '',
                        icon: "",
                        name: itm.name,
                        description: itm.description,
                        sortKey: itm.libraryId,
                        isSelected: false
                    };
                });

                data.push(libraries);

                _.map(libraries, function (itm) {
                    var libraryId = itm.id;

                    promises.push(
                        dataProvider.libraries
                        .getTemplateDocuments(libraryId)
                        .done(function (d) {
                            var documents = _.map(d.data, function (itm, index) {
                                return {
                                    parentId: libraryId,
                                    id: itm.docIdVersionId,
                                    documentId: itm.documentId,
                                    icon: fileExt.getApplicationTypeIcon(itm.applicationType),
                                    name: itm.title,
                                    description: "",
                                    sortKey: libraryId,
                                    isSelected: false
                                };
                            });

                            vm.searchCount(documents.length + vm.searchCount());

                            data.push(documents);
                        })
                    );
                });

                $.when.apply(vm, promises)
                .always(function () {
                    data = _.reduceRight(data, function (a, b) { return a.concat(b); }, []);
                    data = _.sortBy(data, function (itm) { return itm.parentId; });
                    data = _.sortBy(data, function (itm) { return itm.sortKey; });

                    vm.documentTemplates(data);

                    dfd.resolve(data);
                });
            })
            .fail(function (e) {
                vm.documentTemplates([]);

                dfd.reject(e);

                console.error(e);
            });

            return dfd.promise();
        }
        function getUrl(action) {
            return config.webApiUrl + action;
        }
    });
